import 'react-dotenv'

export const env = {
  LOCAL_STORAGE_LOGIN_TOKEN:
    process.env.REACT_APP_LOCAL_STORAGE_LOGIN_TOKEN ?? '',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
  FAIRFASHION_URL: process.env.REACT_APP_FAIRFASHION_URL ?? '',
  GOOGLE_GTAG: process.env.REACT_APP_GOOGLE_GTAG ?? '',
  GOOGLE_GTM: process.env.REACT_APP_GOOGLE_GTM ?? '',
  HOTJAR_ID: process.env.REACT_APP_HOTJAR_ID ?? '',
  HOTJAR_SV: process.env.REACT_APP_HOTJAR_SV ?? '',
  QRCODE_URL: process.env.REACT_APP_QRCODE_URL ?? '',
}
